module Client.Components.Pagination

open Browser.Types
open Feliz
open Feliz.Bulma

let createLoadMoreButton (requestIsRunning: bool) (text: string) (f: MouseEvent -> unit) =
    Bulma.button.button [
        if requestIsRunning then button.isLoading else ()

        color.isSuccess

        prop.onClick f
        prop.text text
        prop.classes [ "flex-center-self" ]
    ]